import React, { ChangeEvent } from 'react';

import { RadioContext } from '@/ui/RadioGroup/atoms/RadioContext';
import { LegendStyled, OptionsStyled, RootStyled } from './styles';
import { GroupProps } from './types';

export const Group = ({ children, legend, onChange, value, className, orientation = 'vertical' }: GroupProps): JSX.Element => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  return (
    <RadioContext.Provider value={{ currentValue: value, onChange: handleChange }}>
      <RootStyled className={className}>
        {legend && <LegendStyled>{legend}</LegendStyled>}
        <OptionsStyled $orientation={orientation}>{children}</OptionsStyled>
      </RootStyled>
    </RadioContext.Provider>
  );
};
